export enum ResponseMessageType {
  Info = "Info",
  Warning = "Warning",
  Error = "Error"
}



// WEBPACK FOOTER //
// ./src/app/core/services/ResponseMessageType.ts